(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 79600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconArrowNarrowRight; }
/* harmony export */ });
/* harmony import */ var _createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61304);
/**
 * @tabler/icons-react v2.42.0 - MIT
 */



var IconArrowNarrowRight = (0,_createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
  "arrow-narrow-right",
  "IconArrowNarrowRight",
  [
    ["path", { d: "M5 12l14 0", key: "svg-0" }],
    ["path", { d: "M15 16l4 -4", key: "svg-1" }],
    ["path", { d: "M15 8l4 4", key: "svg-2" }]
  ]
);


//# sourceMappingURL=IconArrowNarrowRight.js.map


/***/ }),

/***/ 29732:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(27060);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aA": function() { return /* binding */ categoryTitleIconProps; },
/* harmony export */   "gI": function() { return /* binding */ CategoryTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73268);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68711);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1026);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4720);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55075);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79600);





var categoryTitleIconProps = function(theme) {
    return {
        color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getTextColor */ .uu)("brandBlue.6", theme)
    };
};
var CategoryTitle = function(param) {
    var label = param.label, icon = param.icon, description = param.description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Group */ .Z, {
        noWrap: true,
        align: "top",
        children: [
            icon,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .D, {
                        order: 5,
                        children: label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                        size: "xs",
                        color: "dimmed",
                        children: description
                    })
                ]
            })
        ]
    });
};
var CategorySection = function(param) {
    var value = param.value, title = param.title, templates = param.templates, onTemplateClick = param.onTemplateClick, selected = param.selected, collapsible = param.collapsible;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .useMantineTheme */ .rZ)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Accordion.Item */ .U.Item, {
        value: value,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Accordion.Control */ .U.Control, {
                className: collapsible ? "" : "hover:cursor-default",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Accordion.Panel */ .U.Panel, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .List */ .a, {
                    center: true,
                    pl: "xs",
                    pt: "sm",
                    spacing: "xs",
                    children: templates === null || templates === void 0 ? void 0 : templates.map(function(template) {
                        var currentSelected = template.code === (selected === null || selected === void 0 ? void 0 : selected.code);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .List.Item */ .a.Item, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                stroke: 0.2
                            }),
                            className: "cursor-pointer rounded-xs",
                            sx: {
                                backgroundColor: currentSelected ? (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getBackgroundColor */ .dF)("brandBlue.1", theme, "dark.3") : "",
                                "&:hover": {
                                    backgroundColor: currentSelected ? "" : (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getBackgroundColor */ .dF)("brandBlue.0", theme)
                                }
                            },
                            onClick: function() {
                                return onTemplateClick(template);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                                fw: currentSelected ? "bold" : "normal",
                                children: template.title
                            })
                        }, template.code);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (CategorySection);


/***/ }),

/***/ 27060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/head.js
var head = __webpack_require__(89935);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hooks/index.ts + 8 modules
var hooks = __webpack_require__(33892);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./src/components/site/index.ts + 21 modules
var site = __webpack_require__(24613);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(31463);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/MediaQuery/MediaQuery.js + 1 modules
var MediaQuery = __webpack_require__(32700);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Grid/Grid.js + 4 modules
var Grid = __webpack_require__(74969);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/link.js
var next_link = __webpack_require__(19032);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
;// CONCATENATED MODULE: ./src/assets/images/site/happy-people.png
/* harmony default export */ var happy_people = ({"src":"https://static-cny.howxm.com/_next/static/media/happy-people.b54717dc.png","height":428,"width":952,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAfElEQVR42mOAAm4QsVu3OnIfQ40GiL0muI8VJim8pqv04byq1PBtjY0/V1SWbbfyMPVNCfB87uGjrsNwfkmHx821E/8va8isb8gJv7pndtP1EytmVK+b2PqvMbE6kOHxtpk2Fxa1ekFN41iel8fz/0wm+4ZpMxTWlW/jBQDjQDGGUIyGAgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/assets/images/site/dialogue-1.png
/* harmony default export */ var dialogue_1 = ({"src":"https://static-cny.howxm.com/_next/static/media/dialogue-1.ec7f222f.png","height":340,"width":569,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAiElEQVR42mOY21YsPq+/KvH///8MWDAjQ96EMJ+p/Sn/n754sOn////lQOwDxCp3bl1nASliWHZht+jTl4+//fj27f/LV6/+v3379v/nz5//A8HzP//+FzL8//+fBYj9f//50/Lly9cN796/v/n1K1D139//f3951YjNXnYgVvn27Hzyp91m9gDkkHx0crSW2QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/images/site/dialogue-2.png
/* harmony default export */ var dialogue_2 = ({"src":"https://static-cny.howxm.com/_next/static/media/dialogue-2.12c3ca9a.png","height":281,"width":561,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAhklEQVR42mNYMnuKflyQT8vP718F////z8qADg5sXpm6Y+XC/58/f3759evX29+/f7/w48ePgz9+/tzz7///PIY3b15z/fv79wZQ8v+rV6//f/ny5f+vX7/+//zx/f/fzy/3MPz4/5/xy7fvsn/+/NH7//+/1Z/fvz2AOkN+vH5U/HKxWwsAneJayrbVsAMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/assets/images/site/dialogue-3.png
/* harmony default export */ var dialogue_3 = ({"src":"https://static-cny.howxm.com/_next/static/media/dialogue-3.39149da0.png","height":317,"width":592,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAdElEQVR42mPABv7//8/+7/9/hR9AmuHgxDTb7TWx+969eVHz48fPxT9+/Dj25evXx79///z/98vDFoZSTgb149sXf/386dP/t+/e/f8EpH/9+vXyz+/fV359eZUBM9L137//BX/+/LH7//+/8u/fv3lg1gEA/4FM5X1uPFUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/assets/images/site/dialogue-4.png
/* harmony default export */ var dialogue_4 = ({"src":"https://static-cny.howxm.com/_next/static/media/dialogue-4.4e31d8b6.png","height":364,"width":623,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAhElEQVR42mPABT5N6NX55GmnA+EdOsIIov7//6/17++/zN9//275++3b3Q8rlisydE2f77Rg4uQn7z99u/D+/bv/r9+8+f/x48f///7///sbqAGoL1H4zIXr175+/fb/3bt3j758+bLs589fCZ8+flK6tWcvMwPUaL1/f/8GA2kudLcAALG+UWyvORXHAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/images/site/bright-eyes.png
/* harmony default export */ var bright_eyes = ({"src":"https://static-cny.howxm.com/_next/static/media/bright-eyes.e5386a23.png","height":308,"width":326,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAxklEQVR42mNQUNFgYTDnZOxi8GZkwAYUlNVVdeS0xUDsDAYG5q0qlbP22zXmg/jnbboZGZRUNBg9bcwVGYBgaX162ZFprf/3FDb+rGfQ4WcAgUBDMZjR+i3ZPv/fnp78/8jqiv8MDAymDCBgqCTNxAACjAySTupKu1pjAl4lOOj/Z2dhCGMAARhQFFBiYWBgALnFmIGBIcJUSUaCAQ2wqsuIijmbaEsaa8qLMjAwcDKgA1UFOUYRXi5WSX5uLikhPmYGBgYGAPl5JeHSHqRMAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/assets/images/site/bg.jpg
var bg = __webpack_require__(23127);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17474);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-set-state/use-set-state.js
var use_set_state = __webpack_require__(34058);
// EXTERNAL MODULE: ./src/modules/Site/Home/Jumbotron/TextSlider/index.module.scss
var index_module = __webpack_require__(38355);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/modules/Site/Home/Jumbotron/TextSlider/index.tsx








var words = [
    "收集用户反馈",
    "有效触达用户",
    "优化用户体验",
    "开展用户研究",
    "支撑产品迭代"
];
var animationDelay = 2500;
var timer;
var TextSlider = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_set_state/* useSetState */.v)({
        currentIndex: 0
    }), 2), state = ref[0], setState = ref[1];
    var currentIndex = state.currentIndex, prevIndex = state.prevIndex;
    var switchWord = function() {
        var prevIndex = currentIndex;
        setState({
            prevIndex: prevIndex,
            // currentIndex:  currentIndex === words.length - 1 ? 0 : currentIndex + 1,
            currentIndex: (currentIndex + 1) % words.length
        });
    };
    (0,react.useEffect)(function() {
        return function() {
            clearTimeout(timer);
        };
    }, []);
    timer = setTimeout(function() {
        switchWord();
    }, animationDelay);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).words,
        children: words.map(function(word, index) {
            var _obj;
            var classNames = classnames_default()((index_module_default()).word, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (index_module_default()).visible, index === currentIndex), (0,_define_property/* default */.Z)(_obj, (index_module_default()).hidden, index === prevIndex), _obj));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 1,
                align: "center",
                weight: 900,
                className: classNames,
                children: word
            }, index);
        })
    });
};
/* harmony default export */ var Jumbotron_TextSlider = (TextSlider);

// EXTERNAL MODULE: ./src/modules/Site/Home/Jumbotron/index.module.scss
var Jumbotron_index_module = __webpack_require__(71752);
var Jumbotron_index_module_default = /*#__PURE__*/__webpack_require__.n(Jumbotron_index_module);
;// CONCATENATED MODULE: ./src/modules/Site/Home/Jumbotron/index.tsx


















var Jumbotron = function() {
    var breakpoints = (0,MantineProvider/* useMantineTheme */.rZ)().breakpoints;
    var query = (0,next_router.useRouter)().query;
    var smallScreen = (0,hooks/* useSmallerScreen */.B6)();
    var handleTryClick = function() {
        window.scrollTo({
            top: smallScreen ? 1500 : 1380,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        className: (Jumbotron_index_module_default()).container,
        style: {
            backgroundImage: "url(".concat(bg/* default.src */.Z.src, ")")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                        position: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                            spacing: 0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                    spacing: 4,
                                    position: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                                            name: "star2",
                                            className: (Jumbotron_index_module_default()).star,
                                            style: {
                                                animationDelay: "1s"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                                            name: "star2",
                                            className: (Jumbotron_index_module_default()).star,
                                            style: {
                                                animationDelay: "1.15s"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                                            name: "star2",
                                            className: (Jumbotron_index_module_default()).star,
                                            style: {
                                                animationDelay: "1.3s"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                                            name: "star2",
                                            className: (Jumbotron_index_module_default()).star,
                                            style: {
                                                animationDelay: "1.45s"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                                            name: "star2",
                                            className: (Jumbotron_index_module_default()).star,
                                            style: {
                                                animationDelay: "1.6s"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        src: happy_people.src,
                                        width: 476,
                                        imageProps: {
                                            className: "max-w-[100vw]"
                                        },
                                        className: classnames_default()("max-w-[100vw]", (Jumbotron_index_module_default()).happyPeople),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                    className: classnames_default()("slideInBottom", (Jumbotron_index_module_default()).titleAndDesc),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Jumbotron_TextSlider, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                            order: 1,
                                            align: "center",
                                            mb: 12,
                                            weight: 900,
                                            className: "xs:!text-[56px] !text-[32px] xs:!leading-[81px] !leading-[48px]",
                                            children: "从未如此简单"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery/* MediaQuery */.z, {
                                            query: "(max-width: ".concat(breakpoints.xs, ")"),
                                            styles: {
                                                fontSize: 16,
                                                paddingLeft: "2.25rem!important",
                                                paddingRight: "2.25rem!important"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                size: 18,
                                                color: "gray.9",
                                                mb: 36,
                                                align: "center",
                                                children: "在产品内嵌入轻量级问卷，轻松捕捉用户想法，改善服务体验"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                                                gutter: 0,
                                                className: "px-[60px] xs:px-0 w-[369px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                                        span: 12,
                                                        xs: 4,
                                                        className: "!mb-[6px] xs:!pr-[12px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: {
                                                                pathname: constants/* Signup */.Al,
                                                                query: query
                                                            },
                                                            passHref: true,
                                                            legacyBehavior: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                fullWidth: true,
                                                                size: "lg",
                                                                px: "md",
                                                                component: "a",
                                                                styles: {
                                                                    label: {
                                                                        fontSize: 14
                                                                    }
                                                                },
                                                                children: "免费注册"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                                        span: 12,
                                                        xs: 8,
                                                        className: "xs:!pl-[12px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                                            className: "relative",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                                                                        name: "sparkles"
                                                                    }),
                                                                    fullWidth: true,
                                                                    size: "lg",
                                                                    variant: "default",
                                                                    styles: {
                                                                        label: {
                                                                            fontSize: 14
                                                                        }
                                                                    },
                                                                    onClick: handleTryClick,
                                                                    children: "体验一下"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                                    src: bright_eyes.src,
                                                                    width: 163,
                                                                    className: classnames_default()("absolute left-1/2 top-11 hidden xs:inline-block scaleIn", (Jumbotron_index_module_default()).tryTip),
                                                                    alt: ""
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        className: "absolute left-1/2 top-0 translate-x-[250px] hidden md:inline-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            className: classnames_default()("slideInBottom", (Jumbotron_index_module_default()).dialogue),
                            src: dialogue_1.src,
                            width: 308,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        className: "absolute left-1/2 bottom-[-70px] translate-x-[-550px] hidden md:inline-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            className: classnames_default()("slideInBottom", (Jumbotron_index_module_default()).dialogue),
                            src: dialogue_2.src,
                            width: 308,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        className: "absolute left-1/2 top-0 translate-x-[-610px] hidden md:inline-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            className: classnames_default()("slideInBottom", (Jumbotron_index_module_default()).dialogue),
                            src: dialogue_3.src,
                            width: 308,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        className: "absolute left-1/2 bottom-[-70px] translate-x-[260px] hidden md:inline-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            className: classnames_default()("slideInBottom", (Jumbotron_index_module_default()).dialogue),
                            src: dialogue_4.src,
                            width: 308,
                            alt: ""
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Home_Jumbotron = (Jumbotron);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Flex/Flex.js + 1 modules
var Flex = __webpack_require__(26385);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/image.js
var next_image = __webpack_require__(66401);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/gc.png
/* harmony default export */ var gc = ({"src":"https://static-cny.howxm.com/_next/static/media/gc.d14212b6.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPElEQVR42mMAgf8MhQn7Zux6yfDyTX4hA4OyS0y8rquruwADDPxnqMw5Om/HdIbnr8uzGBjUXeIS1WByAKXIEkgryTiuAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/md.png
/* harmony default export */ var md = ({"src":"https://static-cny.howxm.com/_next/static/media/md.208ca06f.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPUlEQVR42mMAgZvmJuxvrS2zzpsYZzNIiOcZycrYy0tLMzKAwHNLczDjo7Wl1jUzk3gGEWFvVzlZFQYoAADIMgvxTQw7lQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/ckt.png
/* harmony default export */ var ckt = ({"src":"https://static-cny.howxm.com/_next/static/media/ckt.c28463c0.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOUlEQVR42mMAAaXAL+u0k9/WA5k+TDwGaUA6EYiDGGBA2unzftWwtxOATF9GDv18IJ0OxHEMDAwsAKSlC3eLyvOFAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/yzw.png
/* harmony default export */ var yzw = ({"src":"https://static-cny.howxm.com/_next/static/media/yzw.502ac8fc.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOUlEQVR42mMAgcxNaxOaN02oATLtOCSlY4B0IRAnMMBA5PIZacXrFmQDmf4cEpLxQDoXiKMZGBgYAL8fC+roS0qeAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/xdm.png
/* harmony default export */ var xdm = ({"src":"https://static-cny.howxm.com/_next/static/media/xdm.99751f5d.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAP0lEQVR42mMAgXsfzpQfeb7pIJDJFx0doRUeHm4WEhKiygADb6/v6X94bdsFIFMmPjzaKjQ0xBeowIyBgYEBAMkyFAIVVDJ8AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/yw.png
/* harmony default export */ var yw = ({"src":"https://static-cny.howxm.com/_next/static/media/yw.f0247523.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANElEQVR4nGOUDLucy8DAcBeI9wGxEBCzAvFfIOYEYnaQAmMggx+IPwKxKBB/AWIQ2wSIGQBNwwkU71MWSAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/jsj.png
/* harmony default export */ var jsj = ({"src":"https://static-cny.howxm.com/_next/static/media/jsj.a7f6cbb9.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOElEQVR4nGP812LEAAQBQGzHyMBQ+5+BgZ2BgZEVyP4MFPsGU6AHxOZAwZNABfpANg+QfQJInwcAgcwLbk7oaPgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/pgy.png
/* harmony default export */ var pgy = ({"src":"https://static-cny.howxm.com/_next/static/media/pgy.617b4e0b.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANklEQVR4nGMU3TGTAQiEgdiLkYHhOZD+AcQsQHwOiD/BFAgBsQxQAe9/BgYpIPsjkH0CSH8CAFVPCtEaZ2lQAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/beeart.png
/* harmony default export */ var beeart = ({"src":"https://static-cny.howxm.com/_next/static/media/beeart.0e800ead.png","height":80,"width":400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQElEQVR42mMAgapE3qlFUdy7gEyTOXWimu8Pqdm82qcqyQADZXG8TUXRPPOATMueQiHbT0fVXZ7tVuFnYGBgAAAkphDpGLUelgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/cx.png
/* harmony default export */ var cx = ({"src":"https://static-cny.howxm.com/_next/static/media/cx.c383589c.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQUlEQVR42mOAgb0T1zT0TpkZzsDA4GGgbxCpqqrKwgACsv+jGRkYGBgOrdCsOzCbJYaBQdPDRF81E6iAnYGBgQEAytUNSxhkrpQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/eclick.png
/* harmony default export */ var eclick = ({"src":"https://static-cny.howxm.com/_next/static/media/eclick.73ca841f.png","height":80,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAK0lEQVR4nGO8sbQlKGBt7ru//5n+3v7D/JeFkeH/3///pRkYGN4wMDK8BwAySBB1WDIUygAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/jy.png
/* harmony default export */ var jy = ({"src":"https://static-cny.howxm.com/_next/static/media/jy.2f14c4db.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPUlEQVR42mMAgeb19nIFzdFGyfHplmnpqYZpaWmaqamp4gww0LrJVjq/PtYNqMAOqEAfKGkJVCTBwMDAAAA9WREQSUWY+AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/ucloud.png
/* harmony default export */ var ucloud = ({"src":"https://static-cny.howxm.com/_next/static/media/ucloud.4f18ba24.png","height":72,"width":360,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANklEQVR4nGO0iP/s9p+BgYORgeEfkOZnYGD4CsR/gJgDiNlACkKAEkxADjMQ8wAxSMF7IAazAeKJDLmEC8w/AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/mz.png
/* harmony default export */ var mz = ({"src":"https://static-cny.howxm.com/_next/static/media/mz.20cd6603.png","height":80,"width":400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANUlEQVR4nB3LoQ0AIBBD0RaPYB4E02PZggEwOML9XJOXmtZbzZI+KjouJh5kBlSmYOBgIY8BMNoI75SfD+AAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/web/qingCloud.png
/* harmony default export */ var qingCloud = ({"src":"https://static-cny.howxm.com/_next/static/media/qingCloud.1ecc59ae.png","height":80,"width":400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARklEQVR4nGPkX5wf9/ft5+9fCuZ9YlAU/sRw/y0HAwMDCxC/AmJuRv6FeXn/vnz/+Dl79iMGST4hhuefmIESz4BYCIg/AACZ5Bh7RyAnHwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/gc.png
/* harmony default export */ var mobile_gc = ({"src":"https://static-cny.howxm.com/_next/static/media/gc.5263ba15.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAASklEQVR4nGP8zwAC9bOnb/axyDJX7MwQEzl2JyaOk/Hly3cMDP+fM17s3cCpV3y6q+No+PtKGZEPCfJSa5/ExPEzvnp5hZHh/z8AX68cpV25VRwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/md.png
/* harmony default export */ var mobile_md = ({"src":"https://static-cny.howxm.com/_next/static/media/md.d36f1af8.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPElEQVR42mMAgWeW5hZvrC2qzpgYJTGIi5WayMr4S8tISzMgg7fWlj6XTY0jGYSFAuzlZI2ACngZGBgYALlNC4jKGlqJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/ckt.png
/* harmony default export */ var mobile_ckt = ({"src":"https://static-cny.howxm.com/_next/static/media/ckt.89d5c589.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAASElEQVR4nGNkk3+nKG/BvpyV8279tQV63EzcGhz/vt74zcDA8B+ItzNyK71TEVZn28XO97Dk9kptRiYuLYF/3659B0qyAPEmAMWtFR6vCFOSAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/yzw.png
/* harmony default export */ var mobile_yzw = ({"src":"https://static-cny.howxm.com/_next/static/media/yzw.cf0807b1.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAO0lEQVR42mMAgdxNaypb1zbHAZk2QnISQUA6EYjTgViQAQTiV82vKVs1OwDI9OWVlgoBCQFxEgMDgzAAvTQL7VKIl3gAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/xdm.png
/* harmony default export */ var mobile_xdm = ({"src":"https://static-cny.howxm.com/_next/static/media/xdm.df1d97db.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATElEQVR4nGP8+vO52t3PN/Y+/PZsuq9cdH9STrzS19c/mP/9+8fLyMh4jfHNre2m//+ynXr2522Tvm7YrLSUeIX3H7+xMDAwiAPxYQANSCIuHmSYQgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/yw.png
/* harmony default export */ var mobile_yw = ({"src":"https://static-cny.howxm.com/_next/static/media/yw.89fdb607.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOUlEQVR4nBXKsQ0AEBQA0U9IqERpB6VZtGYWlTVUGon7xUuuOFP6GiKyMZFg8RARdGiEw0HGhXaF/0twCQXutOHOAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/jsj.png
/* harmony default export */ var mobile_jsj = ({"src":"https://static-cny.howxm.com/_next/static/media/jsj.a9f70dd0.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPElEQVR4nGP812IsysDwv5uBgeEAAyPDEob/DIJANgj8B+IPjP+ajRiAEkVAzgUg/gTEGkDMAsRMQLwOAPQoDH/DeHkIAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/pgy.png
/* harmony default export */ var mobile_pgy = ({"src":"https://static-cny.howxm.com/_next/static/media/pgy.0003c5d5.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANklEQVR4nGMU3TGTAQgCgfg3IwPDXyD9nYGR4RvDfwZmIPs4TIEpEL8BYhUgFgYqBLE/AfEpAL7TDNGVM+mJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/beeart.png
/* harmony default export */ var mobile_beeart = ({"src":"https://static-cny.howxm.com/_next/static/media/beeart.0e800ead.png","height":80,"width":400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQElEQVR42mMAgapE3qlFUdy7gEyTOXWimu8Pqdm82qcqyQADZXG8TUXRPPOATMueQiHbT0fVXZ7tVuFnYGBgAAAkphDpGLUelgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/cx.png
/* harmony default export */ var mobile_cx = ({"src":"https://static-cny.howxm.com/_next/static/media/cx.56336dea.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQUlEQVR42mMAgU8MDBJb5mxurWqscGJgYHDS1dEOU1VV5WSAgY1ZmqJH11q0rG/ldWVg0HQy1FFNBSrgZWBgYAAA7T8Nt/z4wAcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/eclick.png
/* harmony default export */ var mobile_eclick = ({"src":"https://static-cny.howxm.com/_next/static/media/eclick.73ca841f.png","height":80,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAK0lEQVR4nGO8sbQlKGBt7ru//5n+3v7D/JeFkeH/3///pRkYGN4wMDK8BwAySBB1WDIUygAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/jy.png
/* harmony default export */ var mobile_jy = ({"src":"https://static-cny.howxm.com/_next/static/media/jy.408e6f31.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAASUlEQVR4nGNs3WzD+/MDn9qz/TK/mVj+8zIwMPxiYGB89///f04g+zZj525Dzs9PpQ1eHZPk+f+f8Scj4//3//8zcAMlvwPxHQCbeBtzx+cvqgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/ucloud.png
/* harmony default export */ var mobile_ucloud = ({"src":"https://static-cny.howxm.com/_next/static/media/ucloud.22bc6b9a.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOUlEQVR4nCXKQQoAEABE0RGl5D7K2j3cf8uChfBl8eo3jUm1Z0keGxHDSOv8zb1DISzYFTCJxuH1uH/2C5twbGGeAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/mz.png
/* harmony default export */ var mobile_mz = ({"src":"https://static-cny.howxm.com/_next/static/media/mz.20cd6603.png","height":80,"width":400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANUlEQVR4nB3LoQ0AIBBD0RaPYB4E02PZggEwOML9XJOXmtZbzZI+KjouJh5kBlSmYOBgIY8BMNoI75SfD+AAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/images/mobile/qingCloud.png
/* harmony default export */ var mobile_qingCloud = ({"src":"https://static-cny.howxm.com/_next/static/media/qingCloud.447d0359.png","height":80,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARklEQVR4nGPkX5zv//fd5x9f8ud9YVAQ/srw4C07AwMDExC/B2J2Rv6FefH/vnz/9Dl79hMGKT4+hmefWIASr4CYF4i/AACVnhhkTC86pAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/modules/Site/Home/TheyUseIt/index.tsx





































var TheyUseIt = function(param) {
    var _hiddenTitle = param.hiddenTitle, hiddenTitle = _hiddenTitle === void 0 ? false : _hiddenTitle, smallerScreen = param.smallerScreen;
    var groupLogo = [
        [
            ucloud,
            jy,
            eclick,
            gc,
            cx
        ],
        [
            md,
            ckt,
            yzw,
            xdm,
            beeart
        ],
        [
            yw,
            jsj,
            pgy,
            mz,
            qingCloud
        ], 
    ];
    var smLogo = [
        [
            mobile_ucloud,
            mobile_jy,
            mobile_eclick,
            mobile_gc,
            mobile_cx
        ],
        [
            mobile_md,
            mobile_ckt,
            mobile_yzw,
            mobile_xdm,
            mobile_beeart
        ],
        [
            mobile_yw,
            mobile_jsj,
            mobile_pgy,
            mobile_mz,
            mobile_qingCloud
        ], 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                justify: "center",
                align: "center",
                spacing: 64,
                className: "pb-[66px] sm:pb-[127px]",
                children: [
                    !hiddenTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* SiteTitle */.JL, {
                        ta: "center",
                        isIntersecting: isIntersecting,
                        text: smallerScreen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "优秀的产品团队",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "正在使用浩客"
                            ]
                        }) : "优秀的产品团队，正在使用浩客"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        className: classnames_default()("transformSlideInBottomBase delay-300", {
                            transformSlideInBottom: isIntersecting
                        }),
                        children: smallerScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                            wrap: "wrap",
                            justify: "space-between",
                            gap: "50px 0",
                            className: "px-[20px] sm:px-0",
                            children: smLogo.flat().map(function(logo) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: logo.src,
                                    width: 160,
                                    height: 40,
                                    alt: ""
                                }, logo.src);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                            spacing: 48,
                            children: groupLogo.map(function(logos) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                    spacing: 64,
                                    children: logos.map(function(logo) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: logo.src,
                                            width: 180,
                                            height: 36,
                                            alt: ""
                                        }, logo.src);
                                    })
                                }, logos[0].src);
                            })
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var Home_TheyUseIt = (TheyUseIt);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(65149);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/components/business/ChannelPreview/index.tsx
var ChannelPreview = __webpack_require__(24023);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Select/Select.js + 2 modules
var Select = __webpack_require__(41754);
;// CONCATENATED MODULE: ./src/modules/Site/Home/Example/constant.ts


var _obj;
var categoryNameMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, domain/* CampaignTemplateCategory.UserExperience */.tpb.UserExperience, "\uD83C\uDF1F 用户体验"), (0,_define_property/* default */.Z)(_obj, domain/* CampaignTemplateCategory.UserGuidance */.tpb.UserGuidance, "\uD83D\uDC4B 用户引导"), (0,_define_property/* default */.Z)(_obj, domain/* CampaignTemplateCategory.UserStudy */.tpb.UserStudy, "\uD83D\uDE0A 用户研究"), (0,_define_property/* default */.Z)(_obj, domain/* CampaignTemplateCategory.OperatingGrowth */.tpb.OperatingGrowth, "\uD83D\uDD25 运营增长"), (0,_define_property/* default */.Z)(_obj, domain/* CampaignTemplateCategory.ProductsIteration */.tpb.ProductsIteration, "☀️ 产品迭代"), (0,_define_property/* default */.Z)(_obj, domain/* CampaignTemplateCategory.BannerNotice */.tpb.BannerNotice, "\uD83D\uDCE2 横幅通知"), _obj);

;// CONCATENATED MODULE: ./src/modules/Site/Home/Example/MobileContent/TemplateSelector.tsx




var TemplateSelector = function(param) {
    var template = param.template, templates = param.templates, onClick = param.onClick;
    var options = (0,react.useMemo)(function() {
        return templates.map(function(template) {
            return {
                value: template.code,
                label: template.title,
                group: categoryNameMap[template.category]
            };
        });
    }, [
        templates
    ]);
    var handleSelect = function(value) {
        var template = templates.find(function(template) {
            return template.code === value;
        });
        template && onClick(template);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        px: 36,
        w: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, {
            size: "md",
            w: "100%",
            data: options,
            value: template === null || template === void 0 ? void 0 : template.code,
            onChange: handleSelect,
            styles: {
                separatorLabel: {
                    fontSize: 16
                }
            }
        })
    });
};
/* harmony default export */ var MobileContent_TemplateSelector = (TemplateSelector);

;// CONCATENATED MODULE: ./src/modules/Site/Home/Example/MobileContent/index.tsx






var Mobile = function(props) {
    var isIntersecting = props.isIntersecting, templates = props.templates;
    var ref = (0,react.useState)(null), template = ref[0], setTemplate = ref[1];
    (0,react.useEffect)(function() {
        setTemplate(templates[0]);
    }, [
        templates
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: 24,
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                px: 20,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* SiteTitle */.JL, {
                    ta: "center",
                    text: "在数字化系统中体验",
                    isIntersecting: isIntersecting
                })
            }),
            template && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileContent_TemplateSelector, {
                        template: template,
                        templates: templates,
                        onClick: setTemplate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                        px: 8,
                        w: "100%",
                        h: "658px",
                        position: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelPreview/* default */.Z, {
                            channel: "mobileApp",
                            template: template
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MobileContent = (Mobile);

// EXTERNAL MODULE: ./src/components/business/ChannelPreview/Mobile.tsx + 1 modules
var ChannelPreview_Mobile = __webpack_require__(60778);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ScrollArea/ScrollArea.js + 12 modules
var ScrollArea = __webpack_require__(65067);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Accordion/Accordion.js + 10 modules
var Accordion = __webpack_require__(1026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconArrowRight.js
var IconArrowRight = __webpack_require__(27665);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/groupBy.js
var groupBy = __webpack_require__(72068);
// EXTERNAL MODULE: ./src/components/business/CampaigTemplate/CategorySection/index.tsx
var CategorySection = __webpack_require__(79818);
;// CONCATENATED MODULE: ./src/modules/Site/Home/Example/WebContent/Templates.tsx










var Templates = function(props) {
    var ref;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var router = (0,next_router.useRouter)();
    var template = props.template, templates = props.templates, onClick = props.onClick;
    var groupTemplates = (0,react.useMemo)(function() {
        return (0,groupBy/* default */.Z)(templates, "category");
    }, [
        templates
    ]);
    var handleJumpToTemplates = function() {
        router.push(constants/* Templates */.QZ);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        h: "100%",
        w: "274px",
        p: "sm",
        justify: "space-between",
        sx: {
            flexShrink: 0,
            background: "#F6F8F9",
            borderRadius: "8px"
        },
        children: [
            template && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea */.x, {
                h: 650,
                scrollbarSize: 3,
                pr: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
                    variant: "separated",
                    defaultValue: template.category,
                    children: (ref = Object.keys(groupTemplates !== null && groupTemplates !== void 0 ? groupTemplates : {})) === null || ref === void 0 ? void 0 : ref.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySection/* default */.ZP, {
                            value: category,
                            collapsible: true,
                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySection/* CategoryTitle */.gI, {
                                label: categoryNameMap[category],
                                description: ""
                            }),
                            templates: groupTemplates === null || groupTemplates === void 0 ? void 0 : groupTemplates[category],
                            selected: template,
                            onTemplateClick: onClick
                        }, category);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: 4,
                className: "cursor-pointer group",
                onClick: handleJumpToTemplates,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        size: 16,
                        children: "\uD83D\uDCA1 更多模板"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrowRight/* default */.Z, {
                        size: 18,
                        stroke: 2,
                        color: (0,getColor/* getTextColor */.uu)("gray.9", theme),
                        className: "mr-[4px] ease-in duration-200 transition-all group-hover:translate-x-[4px]"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var WebContent_Templates = (Templates);

// EXTERNAL MODULE: ./src/components/business/ChannelPreview/Web.tsx
var Web = __webpack_require__(42987);
// EXTERNAL MODULE: ./src/components/business/PlatformPreview/PreviewActions/index.tsx
var PreviewActions = __webpack_require__(24309);
;// CONCATENATED MODULE: ./src/modules/Site/Home/Example/WebContent/index.tsx










var WebContent = function(props) {
    var isIntersecting = props.isIntersecting, templates = props.templates;
    var previewRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), template = ref[0], setTemplate = ref[1];
    var ref1 = (0,react.useState)("web"), platform = ref1[0], setPlatform = ref1[1];
    (0,react.useEffect)(function() {
        setTemplate(templates[0]);
    }, [
        templates
    ]);
    var handleRefresh = function() {
        var ref;
        (ref = previewRef.current) === null || ref === void 0 ? void 0 : ref.refresh();
    };
    var handleTplApply = function() {
        if (!(template === null || template === void 0 ? void 0 : template.code)) {
            return;
        }
        router.push({
            pathname: "https://app-cny.howxm.com" + constants/* Signup */.Al,
            query: {
                templateCode: template.code
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: 58,
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                spacing: 12,
                px: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* SiteTitle */.JL, {
                    ta: "center",
                    text: "在数字化系统中体验",
                    isIntersecting: isIntersecting
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                sx: {
                    width: 1200,
                    height: "658px",
                    background: "white",
                    border: "1px solid #E3E5E8",
                    borderRadius: 12,
                    padding: 16
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    position: "apart",
                    h: "100%",
                    spacing: 20,
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WebContent_Templates, {
                            templates: templates,
                            template: template,
                            onClick: setTemplate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            pos: "relative",
                            align: "center",
                            w: 874,
                            h: "100%",
                            sx: {
                                borderRadius: 8
                            },
                            style: {
                                width: "".concat(platform === "web" ? "80%" : "")
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewActions/* default */.Z, {
                                    platformChangeable: true,
                                    widgetType: template === null || template === void 0 ? void 0 : template.widget.type,
                                    onRefresh: handleRefresh,
                                    onPlatformClick: setPlatform,
                                    className: "top-0 right-[-60px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    onClick: handleTplApply,
                                    pos: "absolute",
                                    className: "top-[7px] right-[7px] float-right z-10",
                                    children: "选用模板"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                    className: "bg-white sm:bg-[#F6F8F9] w-full h-full",
                                    sx: {
                                        paddingTop: platform !== "web" ? "10px" : undefined,
                                        paddingBottom: platform !== "web" ? "10px" : undefined
                                    },
                                    children: template && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: platform === "web" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Web/* default */.Z, {
                                            previewRef: previewRef,
                                            channel: "web",
                                            template: template
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelPreview_Mobile/* default */.Z, {
                                            previewRef: previewRef,
                                            channel: "mobileApp",
                                            template: template
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Example_WebContent = (WebContent);

;// CONCATENATED MODULE: ./src/modules/Site/Home/Example/index.tsx









var Example = function() {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    var ref = (0,react.useState)([]), templates = ref[0], setTemplates = ref[1];
    (0,domain/* useCampaignTemplatesQuery */.vn_)({
        fetchPolicy: "cache-and-network",
        onCompleted: function onCompleted(data) {
            if (!(0,isEmpty/* default */.Z)(data === null || data === void 0 ? void 0 : data.campaignTemplates)) {
                setTemplates(data === null || data === void 0 ? void 0 : data.campaignTemplates);
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* GridBackground */.o9, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
                    className: "pt-[32px] pb-[60px]",
                    children: smallerScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileContent, {
                        isIntersecting: isIntersecting,
                        templates: templates
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Example_WebContent, {
                        isIntersecting: isIntersecting,
                        templates: templates
                    })
                })
            });
        }
    });
};
/* harmony default export */ var Home_Example = (Example);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Anchor/Anchor.js + 1 modules
var Anchor = __webpack_require__(98558);
;// CONCATENATED MODULE: ./src/assets/images/site/avatar/girl9.png
/* harmony default export */ var girl9 = ({"src":"https://static-cny.howxm.com/_next/static/media/girl9.919929c5.png","height":200,"width":201,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA0klEQVR42mOYpJbIxAAE////Z1wTXKzKAAXL7HIYGWAgkcFEcK1t6bGz4d3/DwQ3bgQKsTIAwT7fOoiiFteIjnWVlf935DX+nGOU+n++RXoCAxBM1IsFKgSCmY2lx2/tmP//1IY5Pxuywv/HGJjuYUACJtPLkv/e27nw99PdS/6cX97zIz3I+b+ZsHAWAwMQWGkoGFipCP9vSQ/5nxtg/f/Mir7/J5b2/LdQFl3JAAOGClKuQGoyEG88NLfp7MF5rbeAbKAYEEhzcTAy4AD+unyMAPHGTRC/jFhMAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/platform.png
/* harmony default export */ var platform = ({"src":"https://static-cny.howxm.com/_next/static/media/platform.ecc72d2b.png","height":756,"width":1400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAcUlEQVR42hXGsRHCMBBE0d3VYWWQkZBQBRlDBXRIC2QUQ0wJ4MFj31mHeMn/fI/fPYmzyIvEsVeUkJn8M4m3TFwl3YvZR2SRCHdvfcIWX3foCtsppukw1BrIMoh6iXwYkE9AR2Wshtm5zN64Ieo2QOAHjIkoCV78AmEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/install.png
/* harmony default export */ var install = ({"src":"https://static-cny.howxm.com/_next/static/media/install.c5c53a47.png","height":648,"width":1168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAj0lEQVR4nAGEAHv/ATQzSwXj/OUY++wAATIuIgK8t671xsjHPBkbF08GAwd2ASEuNygKAA3F/QT8BwMAAf76+vv+Hx0VDyQiHwADAwIsAQAjKis5FSTSEBYPAv4EAAABAgUA/f37ANLX4vjp2OEzAQkhJiozGynPAw0RBv4T8/8HAAcA9+v+AfDu6/v69/gwu/AxQRzx1IwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/style.png
/* harmony default export */ var style = ({"src":"https://static-cny.howxm.com/_next/static/media/style.77b59087.png","height":648,"width":1168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAj0lEQVR4nGP8v/exyCMFBqt7/3gemIqyiTCzM1lycHB8Y2Bg4Pz3799OxkMXv5sxijzkZz579aGBk2fxf8b/aYyMjP9ZWVmBFFMp45c3bxneMDIEi7GzenBwcX/+9OmrASsLMw8zCwsXMzNTC+PLt98YOFmZ4hiZGfs5OZg3fvvyg5uVlUWJiZGJhYn5XwcABSUqJfPAzHQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/js.png
/* harmony default export */ var js = ({"src":"https://static-cny.howxm.com/_next/static/media/js.987e1965.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAlklEQVR42kWNMQqDQBBF5za7Vwh7jdwiXS6QcllIlDSRhOQeqe30GjZ2go0WsvoGRiwe/8+fz4zkxgcoc+simhTzZD4Ig5o1N25FwRSgFJrRlrMqM7idqBcS6EJLPWGH1rDg74JJxwv3x18pn9GJrBDCaBdGwhu88Bf4kb8F87BCD198Byz9wFxpIVipgA/+yemKgnLaAAD0qOhVR1DwAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/ios.png
/* harmony default export */ var ios = ({"src":"https://static-cny.howxm.com/_next/static/media/ios.372d8cc9.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAflBMVEVzaXZyaXZzaHVyaHVyZ3FzaXZyaXZzaXZyaXVyaXZzaXVzaXZzaXZzaXZyaXZyaHZzaXZyaXZzaXZzaXZyaXZyaXZzaXZzaXZzaXZyaXZzaXZzaXZzaHZzaXZzaXZyaHZzaXZzaXZyaHVyaHVzaXZzaXVyaXZzaHVyaHZyaHUfbgbLAAAAJHRSTlMAAAAAAAEBAgIEBRAlKCgpMDI9QEl6fJKen6mus7TS5vb4+/2jgE6RAAAARUlEQVR42gVABRaAIAz9Y2KB3d3i7n9BH0jHsAk0fCieLEUgM/TjUhBUJyJvSuBZdreyB7TPeblGAWa7j68mBMiqvKTwB4UfBCzmhCZVAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/android.png
/* harmony default export */ var android = ({"src":"https://static-cny.howxm.com/_next/static/media/android.a9b3a216.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAlElEQVR42k2POwqDQBCGhwgBG49hE7APOU4esBPsdq/g1dKkm4Wk1l5bu/UDp3DgY+d/TLGilk7CvC3VmtPNqYXhJWNcDFCc4Ric4QpfzfEPwI4XyATjgvjBqBZXzWDshkcmmB1ior0EiyXkWNALTBQ6YWm4fgEm4V6Y4cneiPgESz3mR4Fyfwwqf1vCB9y5bP0D1QZb5XOJymv5TgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/miniapp.png
/* harmony default export */ var miniapp = ({"src":"https://static-cny.howxm.com/_next/static/media/miniapp.6e4e6803.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAmUlEQVR42j2OQQ6CMBBFgV3TY9HqKYxtPA+sCBuvIEz1Ct4FNyS6cA2+VmiTl+nM//2dwttQFtvhrkHtfdYuh3tF03grL+oben98IGantN6E1VlZuIsz8qV2u6hhYrhSn3CFAWZQhTeiYOb1bRMxpbQJdErB0NHE2NGZsEA0tHmHUz2UDHr4xEX5rjnXY5VEmrwtBuX/sVn7ARQrWWWb7yACAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/link.png
/* harmony default export */ var images_link = ({"src":"https://static-cny.howxm.com/_next/static/media/link.9a61a4f7.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAU0lEQVR42k3BMQpAUAAA0PeVzWT7IkW5htxAMbiFsnAEGZQ7OZjVewR/CbQmg85tgsxl1Ou8Hqis4FSIEG3IpWoNlHbAbIHgcNisLi0QlKJKhvABxAYKqvEhkg0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/react.png
/* harmony default export */ var images_react = ({"src":"https://static-cny.howxm.com/_next/static/media/react.f1a61eb2.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA2klEQVR42jWMy0rDUBRFz9CRI/EXBP0cp36FA0FEv0XwE+rAV30ORFQK7aAtfTfpM0lzkzQ3bUmyu28hCzasuw5cMQA46Kvkep1mJ6s0O+opfcN2KAWDIDlnRM2J3Oo8coyzXUjB3zS8rbtLfNgK75aPurcE250Y2r5+bi807rte/jb0dyvRW2xcWRpePLbCBDxkL4MFytwrfRgk/Cm2BMD+7yR8+h4H+LJV+sn90Pku8bYnhq7Sl3a0QmUW4X8a5iN6x9dXUpDl+XHTix+deH3m6s0p/cE0EZEt2Sy62lsrfSAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/vue.png
/* harmony default export */ var vue = ({"src":"https://static-cny.howxm.com/_next/static/media/vue.1904301c.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAuElEQVR42mNw3NNaYLugstLEKKrGPD2V1ywpWcDEOKrWbmFVJUiOwXFnc6/D1qb/ZnHJ/03sYiaY2EZPMotP/u+wrek/SI4BBBz3tV6wXVT138Q6GoztgGzHva0XGGDAYWujt+Oelv8Weem/LfIzfoPYIDGI7h3NzGB6d8s2+9W1/0EYyN4KkWtiZnDYDiRApmxp1ATa+R+EQWyw2HaIZpAiFig9E4SRxWDWMEJpAcftzQJg9naIGAAXg1nSHdwHcAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/uniapp.png
/* harmony default export */ var uniapp = ({"src":"https://static-cny.howxm.com/_next/static/media/uniapp.cbfc77f3.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEUrmTkqmDgmlzUflzAClSQqmDgAlB4rmTkqmDjc6d3H3MnW5tjW5dcwmj1NoVVMoFRJn1E4nEQ3m0MvmjwtmTsrmTkpmDcH9wS8AAAADnRSTlM3N4iIiImJjo75+fz8/DRF0rQAAABCSURBVHjaDcIJFsAQDAXAX0sShJDi/kdt5w0gIecggJz3/AVp1t7rTKChe+sgkLW1mhGiF9XiEXzdzC/j4UgU+fkAY2MCu/OeISwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/tara.png
/* harmony default export */ var tara = ({"src":"https://static-cny.howxm.com/_next/static/media/tara.1b8321cf.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAzElEQVR42mPg1lzHyIAEXDf/B/FRAbf6WlER482KDAwTpEH8juO/AzqP/0zpOP5Li4FHcx0/j9a6+wJaa/4zaO14nbrgc3XPmV//O47//N954pcvSEEwr/b6/9wKy38rxz/4Fzvnz/+mAz8+ASVXNh/8yc4gYLBRmFVmhYq47W4ty6qvDyyqv//XL/1WzwAChl+ZGWDAtvm/rVXN9/9WNd/+29Z9t2AAAp+u78wM+hkPmUAci8rPKlbV3+KBivycmr6zMiADoCAjAw4AADs0U1p7Qq/vAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/images/swift.png
/* harmony default export */ var swift = ({"src":"https://static-cny.howxm.com/_next/static/media/swift.e461db0a.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAvElEQVR42mNABq8LnRnfzA1ghvHfzPJnZHjb6MH4ZqYfy+t1YSxgwSm+PG+m+4Wg6HzT7aX8ptMr7k2vtzaID6T7gGKlqMbXueW8rnF7/LrKNfJ1rVsGkP8aojvDnhuuqNSl+HWh0//XBU4fgPj560pXAaACB5HXCbZlr2NsMl9HWPu/TrS9/zrJ7j9Q7P/rOFsTsM5XMTayQMk5r8OtXr4OtXoFxCuA/OrXYVaxDK/jbZkYkMArRxMeZD4AMqtTv2vfVk0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/QuicklyUse/index.tsx





















var firstRow = [
    {
        img: js.src,
        link: "https://howxm.com/help/articles/web-sdk-intro",
        alt: "浩客 Web SDK 接入"
    },
    {
        img: ios.src,
        link: "https://howxm.com/help/articles/ios-x-sdk",
        alt: "浩客 iOS SDK 接入"
    },
    {
        img: android.src,
        link: "https://howxm.com/help/articles/x-sdk-andriod",
        alt: "浩客 Android SDK 接入"
    },
    {
        img: miniapp.src,
        link: "https://howxm.com/help/articles/x-sdk-miniapp",
        alt: "浩客微信小程序 SDK 接入"
    },
    {
        img: images_link.src,
        link: "https://howxm.com/help/articles/distribution-link",
        alt: "浩客链接分发接入"
    }, 
];
var secondRow = [
    {
        img: images_react.src,
        link: "https://howxm.com/help/articles/npm-web-sdk-intro",
        alt: "浩客 React 接入"
    },
    {
        img: vue.src,
        link: "https://howxm.com/help/articles/npm-web-sdk-intro",
        alt: "浩客 Vue 接入"
    },
    {
        img: uniapp.src,
        link: "https://howxm.com/help/articles/x-sdk-uniapp",
        alt: "浩客 uni-app 接入"
    },
    {
        img: tara.src,
        link: "https://howxm.com/help/articles/x-sdk-miniapp#2-taro",
        alt: "浩客 Taro 接入"
    },
    {
        img: swift.src,
        link: "https://github.com/howxm/howxm-ios-swift-demo",
        alt: "浩客 Swift 接入"
    }, 
];
var ImageLink = function(param) {
    var link = param.link, img = param.img, alt = param.alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
        href: link,
        target: "_blank",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
            className: "hover:cursor-pointer",
            sx: function() {
                return {
                    width: "56px",
                    height: "56px",
                    border: "1px solid #E3E5E8",
                    borderRadius: "8px"
                };
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                src: img,
                width: 28,
                height: 28,
                alt: alt
            })
        })
    }, link);
};
var QuicklyUse = function() {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                    position: "center",
                    px: smallerScreen ? 15 : 0,
                    pt: smallerScreen ? 30 : 110,
                    pb: smallerScreen ? 80 : 110,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        spacing: 32,
                        align: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureHeader */.OX, {
                                isIntersecting: isIntersecting,
                                title: "10 分钟上线，告别漫长研发排期",
                                description: "减少产研介入，全局控制，灵活上下线，PM、用研、运营等业务一人全搞定",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* Conversation */.ri, {
                                    avatar: girl9,
                                    pcWidth: 438,
                                    text: "之前每次产品内调研光排期就两周，现在用浩客在网站/APP/小程序投放问卷，一天就够了！后续还能随时调整题目、样式、发布状态，实在太方便~"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureBox */.Ob, {
                                color: "#F3F6FA",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                    justify: "space-between",
                                    direction: smallerScreen ? "column" : "row",
                                    w: smallerScreen ? "100%" : 1200,
                                    h: smallerScreen ? 474 : 380,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                                            pt: smallerScreen ? 32 : 64,
                                            pb: smallerScreen ? 0 : 64,
                                            px: smallerScreen ? 32 : 64,
                                            justify: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                                                    spacing: 8,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                                            size: 24,
                                                            className: classnames_default()("transformSlideInBottomBase delay-300", {
                                                                transformSlideInBottom: isIntersecting
                                                            }),
                                                            children: "多终端收集，全平台支持"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                            className: classnames_default()("transformSlideInBottomBase delay-300", {
                                                                transformSlideInBottom: isIntersecting
                                                            }),
                                                            children: "Web/App/小程序，用户在哪里，就在哪里收集。浩客 X-SDK 支持所有主流的技术语言架构，集成简单，技术友好是我们所追求的目标。"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                                    spacing: 8,
                                                    noWrap: true,
                                                    children: firstRow.map(function(param) {
                                                        var img = param.img, link = param.link, alt = param.alt;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                                                            link: link,
                                                            img: img,
                                                            alt: alt
                                                        }, link);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                                    spacing: 8,
                                                    noWrap: true,
                                                    children: secondRow.map(function(param) {
                                                        var img = param.img, link = param.link, alt = param.alt;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageLink, {
                                                            link: link,
                                                            img: img,
                                                            alt: alt
                                                        }, img);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                            className: classnames_default()("transformSlideInBottomBaseForImg delay-300", {
                                                transformSlideInBottomForImg: isIntersecting
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                src: platform.src,
                                                alt: "浩客多终端全平台支持示意图",
                                                width: smallerScreen ? "100%" : 700,
                                                height: smallerScreen ? 186 : 378
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                gap: 32,
                                direction: smallerScreen ? "column" : "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureCard */.TT, {
                                        color: "#F3F6FA",
                                        isIntersecting: isIntersecting,
                                        h: smallerScreen ? 382 : 509,
                                        title: "轻松安装 SDK",
                                        description: smallerScreen ? [
                                            "把一段 SDK 代码或组件包集成到系统中，部署，上线，Bang！数据立刻源源不断流进来。"
                                        ] : [
                                            "把一段 SDK 代码或组件包集成到系统中 , 部署，上线，Bang！",
                                            "数据立刻源源不断流进来。"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            src: install.src,
                                            alt: "浩客 SDK 安装示意图",
                                            width: smallerScreen ? "100%" : 584,
                                            height: smallerScreen ? 191 : 324
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureCard */.TT, {
                                        color: "#F3F6FA",
                                        isIntersecting: isIntersecting,
                                        h: smallerScreen ? 382 : 509,
                                        title: "按需设计问卷",
                                        description: [
                                            "丰富的题目组件和场景模板，自定义样式，你的问卷你做主。"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            src: style.src,
                                            alt: "浩客问卷样式自定义设计示意图",
                                            width: smallerScreen ? "100%" : 584,
                                            height: smallerScreen ? 191 : 324
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        }
    });
};
/* harmony default export */ var Home_QuicklyUse = (QuicklyUse);

;// CONCATENATED MODULE: ./src/assets/images/site/avatar/girl7.png
/* harmony default export */ var girl7 = ({"src":"https://static-cny.howxm.com/_next/static/media/girl7.7583f676.png","height":200,"width":200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAxElEQVR42mPY4F7CxAAF6UpanAzYwGz7FInDIS17TkV0vtntX1cHElsbWMoMV7DVsax3sX/+//0JTf/XuxT979YKNweJV4v7sIAVNHqFbVjYUPj/6JLe7w2FGf99dFQOAYUZGaBAOinY9enVrQv/Pz206vetbYu+RTvo/l/TU1YFlnUxVK2wUhD9P7cy+f/mnpL/04qi/l9YO+X/s4PLD4AVWKpJmRopih0FMg/aa0psdtESXnB7y/RXD3bOm8uAB/DAGABVjU0DD5V01AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/AccurateResearch/images/intro.png
/* harmony default export */ var intro = ({"src":"https://static-cny.howxm.com/_next/static/media/intro.81946625.png","height":560,"width":928,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAsElEQVR4nAGlAFr/Ad7n6lbM0tfgVmOX5y9BFw76KDXnACIp+QDy7wICBQX/Adji7k3S2+TeVmyl8hg+HALo9/r/ADlY7QAEBv8A8u0CAevh5FHd1dnemUp/8C9fN/717/EBCAgN+x0QFPkvGB35Ae/k207b0s3irnZY7ShCM//59dUA7/cKBxYL7vhLLQDxAdzq4FPL1s7iWZtS7CMhRQLe/vf+AQkC/ATq+g36JQvt3PRWhMWcmmoAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/modules/Site/Home/AccurateResearch/images/example.png
/* harmony default export */ var example = ({"src":"https://static-cny.howxm.com/_next/static/media/example.cdb04b8b.png","height":760,"width":1344,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAmklEQVR42hXMOwrCQBRG4f/eSWIISUgRQeysLAQ34ALcrrWIlRvQXrCxEBGNxDCTeVyT4nC6j9pO75TiNTFrhEAgAkQEoHTYJZok8dJZu5BeI80LHA97NM87ZlWB1WZr2Idgmu8PbWc8AOldLKfzy18fAQKYSJylMmMolYw2ZWWNd1/S7cOwTiiS4BDDAk4PKTAD0yrBvM5HEH8dX0UUJ+HaJAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/modules/Site/Home/AccurateResearch/index.tsx










var AccurateResearch = function() {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* GridBackground */.o9, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
                    className: "".concat(smallerScreen ? "pb-[77px]" : "pb-[160px]"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                        position: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                            spacing: 32,
                            align: "flex-start",
                            px: smallerScreen ? 20 : 15,
                            pt: smallerScreen ? 40 : 64,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureHeader */.OX, {
                                    isIntersecting: isIntersecting,
                                    title: "千人千面，精准调研 ",
                                    description: "灵活设置投放规则，指定投放时间，精准用户投放，满足个性化调研和用户触达需求",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* Conversation */.ri, {
                                        avatar: girl7,
                                        pcWidth: 438,
                                        text: "只想给刚上完课的学员投放问卷，勾选几下就能设置细颗粒度的投放规则，主打一个精准。"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureBox */.Ob, {
                                    color: "#293440",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                        gap: smallerScreen ? 16 : 32,
                                        direction: smallerScreen ? "column" : "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                className: "px-[10px] py-0 sm:pl-[16px] sm:py-[16px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                    className: "py-[16px] sm:py-[36px] px-[16px]",
                                                    sx: function() {
                                                        return {
                                                            background: "#FFFFFF",
                                                            boxShadow: "0px 6.8px 10.2px rgba(0, 0, 0, 0.05)",
                                                            borderRadius: "16px"
                                                        };
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                        src: intro.src,
                                                        width: smallerScreen ? "100%" : 464,
                                                        h: smallerScreen ? 191 : 276,
                                                        alt: "浩客精准投放规则设置"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                                mt: 2,
                                                className: classnames_default()("transformSlideInBottomForImg delay-300", {
                                                    transformSlideInBottomForImgs: isIntersecting
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                    src: example.src,
                                                    width: smallerScreen ? "100%" : 672,
                                                    h: smallerScreen ? 195 : 380,
                                                    alt: "浩客精准用户投放示例"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            });
        }
    });
};
/* harmony default export */ var Home_AccurateResearch = (AccurateResearch);

;// CONCATENATED MODULE: ./src/modules/Site/Home/Teamwork/images/result.png
/* harmony default export */ var result = ({"src":"https://static-cny.howxm.com/_next/static/media/result.3b5ae4a3.png","height":760,"width":1344,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAdElEQVR42jXJSwrCMBgA4dz/LO6Mey+joJRa0qRJ/tcoBQe+1aRa62WMcQOuIpJHb7mULatqBnIyMzwcgFo763aw14mqnRLeiy13QOy9NHu+dpsSNqbZnGIpXNsoD8BZPwelDjzg9xBRUgRNjTNRwzz4cw++6k6Z6r2SzcwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/modules/Site/Home/Teamwork/images/team.png
/* harmony default export */ var team = ({"src":"https://static-cny.howxm.com/_next/static/media/team.06b009df.png","height":648,"width":1168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAdElEQVR42jXDvQ3CMBAGUFMwQUagi9iLbdgL0dEGiQ6JCjs2d2ffz0eaPOml2nEqjZec89pqaV2IPXBV1ct2Sj74CMREzA8RRu8jVB3uDjM7px0R3b7lh0ZD358W0pUBzOm5vA7bxMz3vDJKFctVQGIjwuc/jBlqPar+VuYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/modules/Site/Home/Teamwork/images/members.png
/* harmony default export */ var members = ({"src":"https://static-cny.howxm.com/_next/static/media/members.c06e9ba0.png","height":648,"width":1168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAj0lEQVR4nAGEAHv/AfDs6zwDAwRHCRAQxwPn0rbqAh8bAwL9wAsNCwgICAc7Ae3r62kAAQBRCQcFEgcGBxL3/PwU+Pz9vw8IC4EBBQHYAf7//wzu8fljBP7zYQsEAxv6BAP98/v8zhIIDZQAAgDLAfb29xj29vedBQYF9gcNDGX98AD4+v/vuwcICCAGBgZKBE41RUQBml0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/modules/Site/Home/Teamwork/index.tsx









var Teamwork = function() {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                    position: "center",
                    pt: smallerScreen ? 45 : 86,
                    px: smallerScreen ? 20 : 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        spacing: 32,
                        align: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureHeader */.OX, {
                                isIntersecting: isIntersecting,
                                title: "发现问题，并解决它们",
                                description: "基于用户的宝贵反馈，明确团队动作，改善服务体验",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* Conversation */.ri, {
                                    pcWidth: 438,
                                    text: [
                                        "只要用户反馈了，我就能发现问题。",
                                        "回收反馈，定位问题，给出改进方案，一气呵成~"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureCard */.TT, {
                                    color: "#F6FAF6",
                                    w: smallerScreen ? "100%" : 1200,
                                    h: smallerScreen ? 382 : 380,
                                    isIntersecting: isIntersecting,
                                    title: "让调研结果一目了然",
                                    direction: smallerScreen ? "column" : "row",
                                    description: smallerScreen ? [
                                        "随反馈录入，自动生成摘要、数据和图表，快速定位用户问题并推进解决。"
                                    ] : [
                                        "随反馈录入，自动生成摘要、数据和图表，快速定位用户",
                                        "问题并推进解决。"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        src: result.src,
                                        alt: "浩客自动生成调研结果摘要、数据与图表",
                                        width: smallerScreen ? "100%" : 711,
                                        height: smallerScreen ? 195 : 376
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                gap: 32,
                                direction: smallerScreen ? "column" : "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureCard */.TT, {
                                        color: "#F6FAF6",
                                        isIntersecting: isIntersecting,
                                        h: smallerScreen ? 382 : 509,
                                        direction: "column",
                                        title: "与团队一起跟进反馈",
                                        description: [
                                            "对关键问题发起讨论，群策群力解决用户问题。"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            src: team.src,
                                            alt: "浩客团队协作跟进用户反馈",
                                            width: smallerScreen ? "100%" : 584,
                                            height: smallerScreen ? 191 : 324
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureCard */.TT, {
                                        color: "#F6FAF6",
                                        h: smallerScreen ? 382 : 509,
                                        direction: "column",
                                        isIntersecting: isIntersecting,
                                        title: "共同打造一流产品体验",
                                        description: smallerScreen ? [
                                            "不限数量协作席位，所有团队成员都可以为产品体验改进添砖加瓦。"
                                        ] : [
                                            "不限数量协作席位，所有团队成员都可以为产品体验改",
                                            "进添砖加瓦。"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            src: members.src,
                                            alt: "浩客不限数量团队协作席位",
                                            width: smallerScreen ? "100%" : 584,
                                            height: smallerScreen ? 191 : 324
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        }
    });
};
/* harmony default export */ var Home_Teamwork = (Teamwork);

;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/cloud.png
/* harmony default export */ var cloud = ({"src":"https://static-cny.howxm.com/_next/static/media/cloud.1bf24ab2.png","height":42,"width":58,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAcUlEQVR42mPQjzzNygAE+pFn7IB4HpA/F0inQ8ROszBAGYpADJIUhPIbgYoiYJI6QM5qIK3OgASAYvOBYvEgBXOAHGmoYjYgZtGPOsME5U8DETP1I84wM2ACkFwziAgC4vlAXTlAk4pAGMru1Y883QoApOs3iU4DWdgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/code.png
/* harmony default export */ var code = ({"src":"https://static-cny.howxm.com/_next/static/media/code.6fabec27.png","height":52,"width":58,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAlUlEQVR42mPQjzxdph95pl8/6kwVkF0HwkB2LZBuBOLpDEBiNlABKwMQAGlGKM0CpWtBCjYDdXTpR51uAOJaILsRSNeBaKCCbSAFE6CqJYBsOyDWBLItoWK5IAUToZzlQBwGxMJAfEI/4jQzkM4AKZgJVaAMNUEByHaHipWDFJQC8WSgnSVAugaIgW4BiZ1p1Y88MxsAjBtTw0gIe64AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/cup.png
/* harmony default export */ var cup = ({"src":"https://static-cny.howxm.com/_next/static/media/cup.ad33b9de.png","height":58,"width":58,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAArElEQVR42k2OoQoCURBFr+BiUUwKBsV9+AVitCiYTQabRsMmDTb9AO2GxaBB8Ad8Cwta/ZLnZ3hgJ+zA4c67c5l5Cj5u/Hy8hhv9CT2jKXpEezLzic5kRd/Ce6CXIpDFScjcRFb0neDdltlBDEekcx7z0oY23gdWhfHqR5hXGEMXUhhKFKnIQlX6O3wZDmxW44Sr2Nol5/aYO0h41yUrjCbGm49t0AXkhKeS9Ad7GGo9wHcUugAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/easy.png
/* harmony default export */ var easy = ({"src":"https://static-cny.howxm.com/_next/static/media/easy.5814f832.png","height":53,"width":58,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAmElEQVR42i2NMQrCQBBFB1QQIWCjYKVVwE7wArJbiDcQ76CNRVLlAOkSAgmEhJQpdk+3OUAeYRbe/jczzK4E41aQQBWMT+GHl2QOF+HKaHyEgz/hrX6DDnG1cCbjt0taH+NfVJj9hauiEZMRGz1e43t9ZRCKE3TB+gN5hZ0OC3ihFNYdGQxsn3XYUj9E/1lrM4KGeiTv2tvMgANhpVsFWZEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/entries.png
/* harmony default export */ var entries = ({"src":"https://static-cny.howxm.com/_next/static/media/entries.83aec873.png","height":56,"width":57,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAoElEQVR42mMAAdNLJcxQOgeIV5leLuWD8pmARCkrlOMKZDcAaTMgngbEmQwwAFWgD8R8ppdLvIH0VyAuhkmEAvEhoIQTlM8DNEkBSEtCFZRaATkngbgDzcRAIM4BMRqA2MLkYgk7SMLscqkMUFMGVNFSEJEAxBOAuBKIOYAKtgAV7AWyy4D0FKA6oK5LJRJml0uUoLpCgBJTgWJiZpdKWAGfi1W7VpbxiwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/event.png
/* harmony default export */ var images_event = ({"src":"https://static-cny.howxm.com/_next/static/media/event.11d01078.png","height":52,"width":52,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEXouiPpuSLouSLouSHnuSPnuCLnuCHouSLnuCHouCHnuCHouSLnuCHnuCHouSHouCHnuCHouSLnuSLnuCLouSLouSHnuSLnuCLouSLouSLouSHouSLouSHouCHnuCHouSLouSFkr576AAAAIXRSTlMAAAAAAAAAICFUVFWDhIuLi5OTk5SUlJSWl5eYo6OjtbX7jUHcAAAARklEQVR42iXKxwGAIBAEwPXQNWBADKDAaf9V+nDeA1e2GL3OUEMRSsZK0w+kx1G11nbYccv4PpNcCKxVGwbkPyucnimFsnx/ggOycKR6VAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/pwd.png
/* harmony default export */ var pwd = ({"src":"https://static-cny.howxm.com/_next/static/media/pwd.b0a15566.png","height":52,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAclBMVEWUG8qTGsyRG8iQG8iQG8eRGsmQGsiQGseQG8iQGsiQG8iRGsmQGsmQGsmQGsmQGsiQGsiQGsiQGsiQGsiQGsmQGsmQGsiQGsiQGsmQGsmQGsmQGsiRG8mQGsiQGsiQGsiQGsiQGsiQGsmQGsiQGsiQGshffLPAAAAAJnRSTlMAAAAAAAAABg0NERgZODk8QHR3eH1+fn+Ijo+PkpaeoKGmqKqrrNA3lSEAAABBSURBVHjaBUAHFkAwDP20iU3t0gg17n9FD1Q9etcEmlpuZgI+17k3gd+Gftw91HDJRhFsfhQ24EopI3NijSISlx9zpQPHnJgoXwAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/role.png
/* harmony default export */ var role = ({"src":"https://static-cny.howxm.com/_next/static/media/role.f1c84a6f.png","height":52,"width":52,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAmUlEQVR42k2PQQ4BQRBFO2O4g+YIs7TgAMIduAIbKzt2rHTvEImwEVuX0B0ONa8mVclU8vJ/9e9UdzmpMEhFoz6vgk9vOMIz+tx3mA6Z6Bxi8N8SHcMUHhL09MIORuqvMIGDs6J5QWX9yadSnrPwDEv9RyWTIMBawgssNNzj7yA6sw1uOuUPW9eqyHYE+UPwg01zOMwFvmvb1UhWUhGsqau9AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/secret.png
/* harmony default export */ var secret = ({"src":"https://static-cny.howxm.com/_next/static/media/secret.11217078.png","height":58,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAh0lEQVR42i3MMQ7CMAyFYS9AKSPHSCUWxrIAEjdiYQHWijKXpELt8docov+THOlLXuLYFmI21OE3v9DhjZNpERo8cMQOFe5o6Jp78Emy7JXRaWRLcY0DDzXnEOK0IX/UmfznkzyGlLd+77W1OFeMxspH3/SuYomEixeu5IhSRSnwxd/PwsxsAcPvauzDA3XZAAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/update.png
/* harmony default export */ var update = ({"src":"https://static-cny.howxm.com/_next/static/media/update.a01c5f31.png","height":58,"width":58,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAk0lEQVR42mMAAdNLJZxAXAfE04B4ChBPML1cqg6WBDI4oYI+QC5MgxYQzwBiQwaoTm+oYnvTS6UZUEUiQLwIxJgGlbQwvVyyF8i/AFSUClVUByImQTm6ZkBrzC6XJAPZxlCxfBAxAYi1IQKlRkAcg+SWBSBCHYhnAK0QAYsiJBuBiqPBHDOwzpKFQFwNxAVQNlgSAFSbVjr+ZtfeAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/images/user.png
/* harmony default export */ var user = ({"src":"https://static-cny.howxm.com/_next/static/media/user.e280a233.png","height":50,"width":58,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAfElEQVR42mMAAe1Zrw2AeBEQzwLiDCBOAWIPkBxMQTsQy0HZNUDsBMSNajNfMiIUzH6tC2U3A7EnEDcjm6ACxB1ARe1AOhiIo4DYEiSHpOgNyB1+WrNeM6NJvJYG4j6g7mognQrE04E4CIjLgdgDpKAPahy6o221Z73uAwArBlAYz724RwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/constant.ts











var goodPoints1 = [
    {
        icon: "entries",
        text: "数据实时回收"
    },
    {
        icon: "cloud",
        text: "顶级云服务提供商"
    },
    {
        icon: "pwd",
        text: "银行级数据加密"
    },
    {
        icon: "secret",
        text: "等保3.0"
    },
    {
        icon: "update",
        text: "每周更新"
    },
    {
        icon: "cup",
        text: "十年积累"
    }, 
];
var goodPoints2 = [
    {
        icon: "easy",
        text: "简单易用"
    },
    {
        icon: "code",
        text: "无需开发"
    },
    {
        icon: "event",
        text: "事件传入"
    },
    {
        icon: "user",
        text: "多人协作"
    },
    {
        icon: "role",
        text: "权限机制"
    }, 
];
var iconMap = {
    entries: entries,
    cloud: cloud,
    pwd: pwd,
    secret: secret,
    update: update,
    cup: cup,
    easy: easy,
    code: code,
    event: images_event,
    user: user,
    role: role
};

;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/Card.tsx




var Card = function(param) {
    var item = param.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        align: "center",
        justify: "center",
        spacing: "sm",
        sx: function(theme) {
            return {
                width: "168px",
                height: "90px",
                background: "rgba(255, 255, 255, 0.4)",
                border: "1px solid #E3E5E8",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.05)",
                borderRadius: theme.radius.md
            };
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                position: "center",
                align: "center",
                className: "w-[32px] h-[32px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    src: iconMap[item.icon].src,
                    alt: item.icon,
                    width: 26
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                children: item.text
            })
        ]
    });
};
/* harmony default export */ var GoodPoints_Card = (Card);

;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/CardList.tsx





var CardList = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        mt: 46,
        spacing: "xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                spacing: "xl",
                position: "center",
                children: goodPoints1.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GoodPoints_Card, {
                        item: item
                    }, item.icon);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                spacing: "xl",
                position: "center",
                children: goodPoints2.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GoodPoints_Card, {
                        item: item
                    }, item.icon);
                })
            })
        ]
    });
};
/* harmony default export */ var GoodPoints_CardList = (CardList);

;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/CarouselList.tsx





var MobileSlideItemWidth = 168;
var MobileSlideItemGap = 16;
var CarouselItem = function(param) {
    var data = param.data;
    var scrollArea = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref;
        (ref = scrollArea.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
            left: scrollArea.current.scrollWidth / 2 - MobileSlideItemWidth / 2 - MobileSlideItemGap / 2,
            behavior: "smooth"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea */.x, {
        viewportRef: scrollArea,
        type: "never",
        style: {
            height: 90
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
            noWrap: true,
            px: "sm",
            children: data.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GoodPoints_Card, {
                    item: item
                }, item.icon);
            })
        })
    });
};
var CarouselList = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        mt: 32,
        spacing: "xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                className: "w-screen overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselItem, {
                    data: goodPoints1
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                className: "w-screen overflow-hidden",
                position: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselItem, {
                    data: goodPoints2
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/Site/Home/GoodPoints/index.tsx








var GoodPoints = function() {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        rootMargin: "0px 0px -200px 0px",
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                pt: smallerScreen ? 120 : 168,
                pb: 96,
                justify: "center",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        ta: "center",
                        size: smallerScreen ? 32 : 40,
                        px: smallerScreen ? 36 : "unset",
                        className: classnames_default()("transformSlideInBottomBase delay-150", {
                            transformSlideInBottom: isIntersecting
                        }),
                        children: "这些小事，我们当然也考虑到了"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        className: classnames_default()("transformSlideInBottomBase delay-300", {
                            transformSlideInBottom: isIntersecting
                        }),
                        children: smallerScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselList, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GoodPoints_CardList, {})
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var Home_GoodPoints = (GoodPoints);

;// CONCATENATED MODULE: ./src/modules/Site/Home/CustomerSay/images/ckt.png
/* harmony default export */ var images_ckt = ({"src":"https://static-cny.howxm.com/_next/static/media/ckt.fa1b082b.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAwElEQVR42mMwNzNjZCAELMzNlXT19MrYRCUbgPROL2cXPpC4qak+RLOolFSApob6fy8Xx/8aKsr/gUJKUL3MYJKNTd6lKif9/9Ip3V8binP/OxvZ94PEJ9dlQBTICSrMAkr+P7lpxe/ti6b/q0xL+H/j0A5tJFcw7ixOiPm/blLb32n1JX8enNzz/921kyVwaTtj6yBFcb3/QMt+Welp/T6yZsG1u0e2WSJ7RFhVRtTJSsfOFMjWBWKw609vW80EABnZQSwOL9W3AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/CustomerSay/images/jsj.png
/* harmony default export */ var images_jsj = ({"src":"https://static-cny.howxm.com/_next/static/media/jsj.67fbcd0d.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAwUlEQVR42mOAAiYYY9uMTjY0MVEmMGlsZc0gIHeMgUHoOgODhCoDGPBAFbFLmvjYW/yvSY/5X58e/T/Y2eYqzAQY8F5ck/7/7YGVP17sXvJ/YUXSV5ChDDDQnRPttGNS3f9LKyb/ur5myv8dM5vfpZTmSjDAwJZl842OzGr9//rQ6v/PZrT+f1dX9P/mjEn6EFf3VjCD6OkJDm6HZza+OVaR+vETA8PU/1H2rAwwcHh2OzMDxFKhiT05UjDxlzoijACd6kipzzn7KwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/CustomerSay/images/cxhub.png
/* harmony default export */ var cxhub = ({"src":"https://static-cny.howxm.com/_next/static/media/cxhub.ab564d7e.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA10lEQVR42mMAgQf758sCKdZbl84EAbHnQiD71Zn1XC+uH2diAIEru5e43rp4avflU4f/37167v/9q2fm//94jIkBBg6unhG7bM6UN5M7mz53NdX+Or19ybcnx1b2MsDA3hklsnObsxfWZcd8rMqI/DOlJmPD/nmNOgwwMCOMQXDT3J7/x7Ys+X9865L/G+d0/c9jYOBnAIFDKyYxMwDBufWTW85snPn/zIYZ/88D2QxAsG9pPzPDlo5ERgYoWNaQ2gXCDFCwrSsZIndwajaQgQoOTM0CiwEA2nNkZasOQj4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/CustomerSay/images/uCloud.png
/* harmony default export */ var uCloud = ({"src":"https://static-cny.howxm.com/_next/static/media/uCloud.c92fb41e.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA0UlEQVR42mMAgbXTypgY0MD82bNYwIydM3PAkicWlmieXVG68+yM4qlLW6cYMDD854OrLg5RFtsxM+f9ja2T/z/eNfv/tgnZ13YeY5D7/3szM1hBc7yK2fLGyP/3d8z6cXfbjP/b+3JvMaxk4ICbMK2uxXLPxIL/j7fN/v10z4L/V1Z0PwxmmKaZ5DlfFaxgSl1HfGWE8f+VdUn/90+u/z+zuP/cpMRZucWOc/TACq4w2CjM7zHJCAli8C8OLHQOiVmkAjd+38QIRgYcYFZSPxMAtLRXMG/Q9ZMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/CustomerSay/images/cx.png
/* harmony default export */ var images_cx = ({"src":"https://static-cny.howxm.com/_next/static/media/cx.4a7de655.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA1ElEQVR42mMAgXB7UyYQ3VmUxhXvbqvdWZjKBuIHWBsxMYTYGDCDOL6W+vqJzqb3o+0N/vqbat30sTJQZACBUAt1kG4QOLK4Off/+zObfs6uSfsP5E9lQAJ85dGer3cvnPD//t6lv9ZPaf4f7Wq+mgEJCLRmhLx5cXTN/wd7l/y8sW3+/4wAh0Vw2YrEYD4g9XZGVer/44u6//fkR/8H8mfDFYTbGXJoS/HfBTLfuRurPAfS/2005dqRbOBkNFYUV4vysBUGcsRcTbQMrdVlJBgYGBgA4yBFkD3bckIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/CustomerSay/images/beeArt.png
/* harmony default export */ var beeArt = ({"src":"https://static-cny.howxm.com/_next/static/media/beeArt.7587a430.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAApElEQVR42mOAAkYGTMAEYzBDKFZ7IHENiFcAsSZc0dK2fFYQqy4lYOqJlZP/n9s05/+suqxbcHMOrZ0PNmpJe/G2I8sn/b++ff7fFd1lL4FC/CgWbphcd33/4v7/B5dO+LdhavO3+dkWomCJikR/FhAd5mkd1poe/r8jK/J/Y2ZoLUisISMM4r4T85rAvnAz1fNzNdKOZMAGNvdXwL31//E+uLcBwMI5rYRwHfYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/CustomerSay/index.tsx













var Item = function(props) {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    var _customer = props.customer, avatar = _customer.avatar, name = _customer.name, account = _customer.account, title = _customer.title, content = _customer.content, _className = _customer.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        className: classnames_default()("transformSlideInBottomBase delay-300", className, {
            "!mt-0": smallerScreen,
            transformSlideInBottom: props.isIntersecting
        }),
        sx: function() {
            return {
                display: "inline-block",
                width: smallerScreen ? "100%" : "376px",
                background: "#F6F8F9",
                borderRadius: "8px",
                padding: "24px"
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: 8,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: 10,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                src: avatar.src,
                                alt: name,
                                width: 64,
                                height: 64
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                            spacing: 0,
                            c: "#495057",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    children: [
                                        "@\xa0",
                                        account,
                                        "\xa0\xa0",
                                        title
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    size: 16,
                    children: content
                })
            ]
        })
    });
};
var customers = [
    {
        avatar: images_ckt,
        name: "赵文文",
        account: "创客贴",
        title: "产品经理",
        content: "问卷上线第一周，我们就收到上万条数据，回收率高了3倍不止！"
    },
    {
        avatar: images_jsj,
        name: "万钒",
        account: "金数据",
        title: "产品经理",
        content: "网站和小程序集成浩客只花了不到半天的时间，现在在产品内发一个问卷实在太方便了！"
    },
    {
        avatar: beeArt,
        name: "笪磊",
        account: "BeeArt",
        title: "产品经理",
        content: "我们通过浩客给不同的用户群投放调研问卷，收集到更加精准有效的用户反馈。"
    },
    {
        avatar: uCloud,
        name: "Lai",
        account: "UCloud",
        title: "用户研究",
        content: "浩客的投放机制非常灵活，现在常规的体验指标我们都用浩客来收集，对用户也不会造成打扰。"
    },
    {
        avatar: images_cx,
        name: "雪岩",
        account: "彩漩",
        title: "产品经理",
        content: "浩客让我们在产品的早期阶段获得了非常多来自客户的宝贵反馈，这些信息将会指导我们产品的开发过程。"
    },
    {
        avatar: cxhub,
        name: "龙国富",
        account: "CXHub",
        title: "主理人",
        content: "浩客让我们内部不再是“我感觉”或“我认为”这类型拍脑袋的无效讨论，轻松捕获用户的真实想法，用量化数据说话。"
    }, 
];
var CustomerSay = function() {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: smallerScreen ? 32 : 64,
                    pb: smallerScreen ? 60 : 100,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* SiteTitle */.JL, {
                            ta: "center",
                            text: "朋友们这么说",
                            isIntersecting: isIntersecting
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                            direction: smallerScreen ? "column" : "row",
                            columnGap: smallerScreen ? 0 : 24,
                            rowGap: smallerScreen ? 8 : 24,
                            justify: "center",
                            align: "flex-start",
                            wrap: "wrap",
                            px: smallerScreen ? 20 : 0,
                            children: customers.map(function(customer, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                    customer: customer,
                                    isIntersecting: isIntersecting
                                }, index);
                            })
                        })
                    ]
                })
            });
        }
    });
};
/* harmony default export */ var Home_CustomerSay = (CustomerSay);

;// CONCATENATED MODULE: ./src/assets/images/site/avatar/girl12.png
/* harmony default export */ var girl12 = ({"src":"https://static-cny.howxm.com/_next/static/media/girl12.c8419e0f.png","height":256,"width":248,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAyUlEQVR42mMAgX2W5Uwg+nbNNKEz+e3yIPYFhlpGBhBYq5rPBKJ3MBQobLIsf7zHof7/NrXSKJDYNr1yZoY1tbmsIM6CgpRJRxe3/z85p/v/2tLS4yCx51uXMzNAgXF9pvv/t6cn/f50cervhb0xf4BiJgwwoKck6uKkKf+/NzXs/9TsqP++eor/dZTESxlgwFRWmg1IufAzMSQD6TwWdpYOYzkRFQYkwAhjVC1bw7hhbgMjTAwOjIQYGGvDbRkL/cyYHDSlmWDiAK6fPTj6B+AcAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Home/NewFeature/images/ai.png
/* harmony default export */ var ai = ({"src":"https://static-cny.howxm.com/_next/static/media/ai.015bd315.png","height":760,"width":1344,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAoUlEQVR42gWAua4BURiAv/Of35yYubmLS0GCKBQUEssbKD2KF/FmKrVCgcoySGbGkrEMMY3ReGJU+9FifpNkJ2EmQI5WOWBzjFCHDHPGDlaZxVlH79fSadYIzReV/zOq6fXy7eXpVQuP5HQXtS+evEjrLfSWoL5vJAgcehf7znuyDGMOWUz1LySKY6TY7lBqdtkfUgo/Ph5vnDGspzNO6y0fUoc0s4GUTNwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/modules/Site/Home/NewFeature/images/userSegment.png
/* harmony default export */ var userSegment = ({"src":"https://static-cny.howxm.com/_next/static/media/userSegment.5fd76676.png","height":648,"width":1168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAYElEQVR42h3JwQ3CMBAF0fnrtUUNiMJoimYJF5L4b6wcnjTS6Lv9PpLeY4yNqvjvO5mNbAkU2Xt/2fPZQojg7APby0QRpOBYmPZ5eLZHSxxBLFVFFsheISmjqeAeXii4AFmtLR6qhQNAAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/modules/Site/Home/NewFeature/images/webhook.png
/* harmony default export */ var webhook = ({"src":"https://static-cny.howxm.com/_next/static/media/webhook.cfe305f9.png","height":648,"width":1168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAXklEQVR42iWNQQ6AMAgEl7aJpv/x5Id9i++xkVABaUsy7GHDQMx8ichZa2055+TuICI8zGjfC1LV28wP6R2JgG3bAXiwdgokRVNKVo8xGzE7p6AAoKmNHO54s659WX73WjGkII+LjgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/modules/Site/Home/NewFeature/index.tsx










var NewFeature = function() {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                    position: "center",
                    className: "pt-[45px] sm:pt-[168px] px-[20px] sm:px-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        spacing: 32,
                        align: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureHeader */.OX, {
                                isIntersecting: isIntersecting,
                                title: "AI 加持，闭环管理用户反馈",
                                description: "没有 AI 能力的产品是不完整的，浩客还有更多实用的能力模块",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* Conversation */.ri, {
                                    avatar: girl12,
                                    pcWidth: 438,
                                    text: [
                                        "做问卷和数据分析，挺头大的，AI 帮我搞定！产品模块还挺多，帮我闭环管理用户，不错过任何消息。", 
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureCard */.TT, {
                                    w: smallerScreen ? "100%" : 1200,
                                    h: smallerScreen ? 382 : 380,
                                    isIntersecting: isIntersecting,
                                    title: "AI Powered：让你省心省力",
                                    direction: smallerScreen ? "column" : "row",
                                    description: smallerScreen ? [
                                        "浩客已经全面接入 AI 的能力，让 AI 帮你制作问卷，美化样式，甚至帮你自动化出一份分析报告。"
                                    ] : [
                                        "浩客已经全面接入 AI 的能力，让 AI 帮你制作问卷，美化",
                                        "样式，甚至帮你自动化出一份分析报告。", 
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        src: ai.src,
                                        alt: "浩客 AI 制作问卷、美化样式并自动生成分析报告",
                                        width: smallerScreen ? "100%" : 672,
                                        height: smallerScreen ? 195 : 378
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                                gap: 32,
                                direction: smallerScreen ? "column" : "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureCard */.TT, {
                                        isIntersecting: isIntersecting,
                                        h: smallerScreen ? 382 : 509,
                                        direction: "column",
                                        title: "用户群组：关注每一个用户",
                                        description: smallerScreen ? [
                                            "自动汇总应用内用户所有的反馈调研记录，丰富用户画像，并可针对不同的群组进行后续的调研和互动。", 
                                        ] : [
                                            "自动汇总应用内用户所有的反馈调研记录，丰富用户画像，",
                                            "并可针对不同的群组进行后续的调研和互动。", 
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            src: userSegment.src,
                                            alt: "浩客用户群组与用户画像",
                                            width: smallerScreen ? "100%" : 584,
                                            height: smallerScreen ? 191 : 324
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FeatureCard */.TT, {
                                        h: smallerScreen ? 382 : 509,
                                        direction: "column",
                                        isIntersecting: isIntersecting,
                                        title: "推送与集成：不错过任何一条反馈",
                                        description: smallerScreen ? [
                                            "反馈数据可直接推送至企业微信、钉钉、飞书中，或通过 Webhook 推送到自有 IT 进行后续数据留档和处理。", 
                                        ] : [
                                            "反馈数据可直接推送至企业微信、钉钉、飞书中，或通过",
                                            "Webhook 推送到自有 IT 进行后续数据留档和处理。", 
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            src: webhook.src,
                                            alt: "浩客反馈数据推送至企业微信、钉钉、飞书及 Webhook 集成",
                                            width: smallerScreen ? "100%" : 584,
                                            height: smallerScreen ? 191 : 324
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        }
    });
};
/* harmony default export */ var Home_NewFeature = (NewFeature);

;// CONCATENATED MODULE: ./src/modules/Site/Home/Faq/constant.ts
// 单一数据源：同时用于页面可见 FAQ 区块与 FAQPage JSON-LD，避免 cloaking
var faqList = [
    {
        question: "HowXM 浩客是什么？",
        answer: "HowXM（浩客）是一款应用内用户体验调研与反馈工具，帮助企业在 Web 网站、App、微信小程序等数字化产品内嵌入轻量级问卷、评价和通知，实时收集用户反馈，开展 NPS、满意度（CSAT）等体验调研，并精准触达用户。"
    },
    {
        question: "HowXM 支持哪些平台？",
        answer: "HowXM 提供 Web SDK、iOS SDK、Android SDK 和微信小程序 SDK，可在网站、移动 App 和小程序中嵌入问卷与通知；同时支持通过链接或二维码分享对外表单，无需开发即可投放。"
    },
    {
        question: "HowXM 和传统问卷工具有什么区别？",
        answer: "传统问卷工具依赖站外链接，触达率低、场景割裂。HowXM 在产品内部按用户行为、属性和时机精准触发问卷，所见即所得地在真实使用场景中收集反馈，回收率和数据质量更高，并能将反馈与具体用户和行为关联。"
    },
    {
        question: "HowXM 适合哪些人使用？",
        answer: "HowXM 适合产品经理、用户体验（UED）设计师、客户成功和市场运营团队，用于功能反馈收集、NPS 调研、满意度调研、A/B 版本测试、付费流失调研、新功能引导和促销通知等场景。"
    },
    {
        question: "HowXM 如何收费？是否有免费版？",
        answer: "HowXM 提供免费套餐和多档付费套餐，支持免费注册试用。具体功能与价格请查看定价页面（https://howxm.com/pricing）。"
    },
    {
        question: "使用 HowXM 需要开发投入吗？",
        answer: "基础使用只需一次性集成 SDK 或嵌入代码；之后问卷的创建、投放规则配置和数据分析均可在后台可视化完成，无需额外开发。对外表单则可零代码直接通过链接投放。"
    }, 
];

;// CONCATENATED MODULE: ./src/modules/Site/Home/Faq/index.tsx






var Faq = function() {
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
        className: smallerScreen ? "py-[60px]" : "py-[120px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: smallerScreen ? 24 : 48,
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    order: 2,
                    align: "center",
                    weight: 900,
                    className: "xs:!text-[40px] !text-[28px]",
                    children: "常见问题"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
                    variant: "separated",
                    radius: "md",
                    className: "w-full max-w-[800px]",
                    defaultValue: faqList[0].question,
                    children: faqList.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* Accordion.Item */.U.Item, {
                            value: item.question,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion.Control */.U.Control, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        weight: 600,
                                        size: smallerScreen ? "md" : "lg",
                                        children: item.question
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion.Panel */.U.Panel, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        color: "gray.7",
                                        size: smallerScreen ? "sm" : "md",
                                        children: item.answer
                                    })
                                })
                            ]
                        }, item.question);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Home_Faq = (Faq);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Card/Card.js + 4 modules
var Card_Card = __webpack_require__(4588);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 2 modules
var SimpleGrid = __webpack_require__(58262);
;// CONCATENATED MODULE: ./src/modules/Site/Home/Ghost/index.tsx







var Ghost = function(param) {
    var posts = param.posts;
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    var Item = function(param) {
        var post = param.post;
        var _feature_image_alt;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* Card */.Z, {
            padding: "xl",
            component: "a",
            href: post.url,
            target: "_blank",
            className: "transition-transform hover:scale-105 shadow hover:shadow-lg max-w-[384px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card/* Card.Section */.Z.Section, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: post.feature_image,
                        alt: (_feature_image_alt = post.feature_image_alt) !== null && _feature_image_alt !== void 0 ? _feature_image_alt : post.title,
                        styles: {
                            image: {
                                height: "160px !important"
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    fw: 500,
                    size: "lg",
                    mt: "md",
                    lineClamp: 1,
                    children: post.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    mt: "xs",
                    c: "dimmed",
                    size: "sm",
                    lineClamp: 3,
                    children: post.excerpt
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: smallerScreen ? 32 : 64,
                    align: "center",
                    pb: smallerScreen ? 60 : 100,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* SiteTitle */.JL, {
                            ta: "center",
                            text: "最新的实践和案例",
                            isIntersecting: isIntersecting
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                            cols: smallerScreen ? 1 : 3,
                            spacing: "xl",
                            className: "px-5",
                            children: posts === null || posts === void 0 ? void 0 : posts.map(function(post) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                    post: post
                                }, post.id);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            variant: "default",
                            component: "a",
                            target: "_blank",
                            href: constants/* Institute */.Q4,
                            style: {
                                height: 48,
                                fontSize: "14px"
                            },
                            children: "\uD83D\uDC49\uD83D\uDC49 阅读更多信息"
                        })
                    ]
                })
            });
        }
    });
};
/* harmony default export */ var Home_Ghost = (Ghost);

;// CONCATENATED MODULE: ./src/modules/Site/Home/index.tsx
















var Home = function(param) {
    var posts = param.posts;
    var smallerScreen = (0,hooks/* useSmallerScreen */.B6)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: 0,
        className: "overflow-x-hidden xs:overflow-x-visible pt-[59px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Jumbotron, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_TheyUseIt, {
                hiddenTitle: false,
                smallerScreen: smallerScreen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Example, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_QuicklyUse, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_AccurateResearch, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Teamwork, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_NewFeature, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_GoodPoints, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_CustomerSay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Faq, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FooterWrapper */.V6, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Ghost, {
                    posts: posts
                })
            })
        ]
    });
};
/* harmony default export */ var Site_Home = (Home);

// EXTERNAL MODULE: ./src/plugins/crisp/index.ts
var crisp = __webpack_require__(7897);
;// CONCATENATED MODULE: ./src/pages/index.tsx









var homeTitle = "浩客HowXM官网 - 数字化系统必备的应用内调研、评价、通知工具 - 简单好用的体验分析工具 - NPS调研工具";
var structuredData = [
    {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "浩客HowXM",
        legalName: "西安数据如金信息科技有限公司",
        url: constants/* brandingUrl */.$t,
        logo: "".concat(constants/* brandingUrl */.$t, "/logo.png"),
        email: "support@howxm.com"
    },
    {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "浩客HowXM",
        url: constants/* brandingUrl */.$t,
        inLanguage: "zh-CN"
    },
    {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        name: "浩客HowXM",
        applicationCategory: "BusinessApplication",
        operatingSystem: "Web, iOS, Android, WeChat Mini Program",
        url: constants/* brandingUrl */.$t,
        offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "CNY"
        },
        description: "浩客HowXM 是应用内用户体验调研与反馈工具，支持在 Web、App、小程序中嵌入问卷、NPS 调研、满意度调研与通知，精准收集并分析用户反馈，优化用户体验。"
    },
    {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqList.map(function(item) {
            return {
                "@type": "Question",
                name: item.question,
                acceptedAnswer: {
                    "@type": "Answer",
                    text: item.answer
                }
            };
        })
    }, 
];
var Site = function(param) {
    var referer = param.referer, posts = param.posts;
    (0,hooks/* useAccountSourceTrack */.j3)(referer);
    (0,crisp/* useCrisp */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(site/* SiteLayout */.Iv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* SiteSEO */.EI, {
                title: homeTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* StructuredData */.Jr, {
                data: structuredData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        children: "body {\n            min-width: unset !important;\n          }"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Site_Home, {
                posts: posts
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Site);


/***/ }),

/***/ 38355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"words":"TextSlider_words__Qup34","word":"TextSlider_word__D0pyS","visible":"TextSlider_visible__VnuH5","slide-in":"TextSlider_slide-in__IPZOX","hidden":"TextSlider_hidden__qceb5","slide-out":"TextSlider_slide-out__w2yCh"};

/***/ }),

/***/ 71752:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Jumbotron_container__2x715","tryTip":"Jumbotron_tryTip___Nw_V","dialogue":"Jumbotron_dialogue__6knep","happyPeople":"Jumbotron_happyPeople__TEEjP","scaleSlideInBottom":"Jumbotron_scaleSlideInBottom__0VMNG","titleAndDesc":"Jumbotron_titleAndDesc__01R7A","star":"Jumbotron_star__8JaZL","starIn":"Jumbotron_starIn__Ncz1d"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2525,3703,8329,1958,4476,7094,1404,3226,9774,2888,179], function() { return __webpack_exec__(29732); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);